'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _ReduxComponent2 = require('./ReduxComponent');

var _ReduxComponent3 = _interopRequireDefault(_ReduxComponent2);

var _identityReducer = require('nanotools/lib/identityReducer');

var _identityReducer2 = _interopRequireDefault(_identityReducer);

var _invariant = require('nanotools/lib/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function indirectReducer(state, action) {
	return this.__internalReducer(state, action);
}

var DynamicReducerComponent = function (_ReduxComponent) {
	(0, _inherits3.default)(DynamicReducerComponent, _ReduxComponent);

	function DynamicReducerComponent() {
		(0, _classCallCheck3.default)(this, DynamicReducerComponent);

		// Initial reducer is as defined on the class body.
		var _this = (0, _possibleConstructorReturn3.default)(this, (DynamicReducerComponent.__proto__ || (0, _getPrototypeOf2.default)(DynamicReducerComponent)).call(this));

		if (_this.reducer) {
			_this.__internalReducer = _this.reducer;
		} else {
			_this.__internalReducer = _identityReducer2.default;
		}
		// Replace reducer with a layer of indirection
		_this.reducer = indirectReducer.bind(_this);
		return _this;
	}

	// Imitate the Redux API


	(0, _createClass3.default)(DynamicReducerComponent, [{
		key: 'replaceReducer',
		value: function replaceReducer(nextReducer) {
			/* eslint-disable no-undef */
			if (process.env.NODE_ENV !== 'production') {
				/* eslint-enable no-undef */
				(0, _invariant2.default)(typeof nextReducer === 'function', 'DynamicReducerComponent of type ' + this.displayName + ' (mounted at location ' + this.path + ') is replacing its reducer with a non-function.');
			}

			this.__internalReducer = nextReducer;

			// The Redux API sends some junk action to a new reducer when store.replaceReducer is called.
			// We will do the same.
			if (this.isMounted()) {
				this.store.dispatch({ type: '@@redux-components/INIT' });
			}
		}
	}]);
	return DynamicReducerComponent;
}(_ReduxComponent3.default);

exports.default = DynamicReducerComponent;